import { ref, watch, onMounted } from "@vue/composition-api";
import { DefaultConfigs, IPadProConfigs } from "../../services/DefaultConfigs";

export default function useBoxplotChartBoxplots(dataRef, configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef) {
  const boxplots = ref([]);

  const updateDataSet = () => {
    if (!dataRef?.value?.boxplots || !xRef?.value || !yRef?.value) {
      boxplots.value = [];
      return;
    }

    const boxWidth = DefaultConfigs.BoxplotChart.boxWidth;
    const halfBoxWidth = boxWidth / 2;
    const extremeWidth = DefaultConfigs.BoxplotChart.extremeWidth;
    const halfExtremeWidth = extremeWidth / 2;

    const halfXBandwidth = xBandwidthRef.value / 2;
    const convertedData = [];

    for (const boxplot of dataRef.value.boxplots) {
      convertedData.push({
        box: {
          x: xRef.value(boxplot.x) + halfXBandwidth - halfBoxWidth,
          y: yRef.value(boxplot.q3),
          width: boxWidth,
          height: yRef.value(boxplot.q1) - yRef.value(boxplot.q3),
          backgroundColor: boxplot.colors.boxBackground,
          strokeColor: boxplot.colors.boxStroke,
          strokeWidth: DefaultConfigs.BoxplotChart.boxStrokeWidth,
        },
        median: boxplot.median != null && {
          x1: xRef.value(boxplot.x) + halfXBandwidth - halfBoxWidth,
          y1: yRef.value(boxplot.median),
          x2: xRef.value(boxplot.x) + halfXBandwidth + halfBoxWidth,
          y2: yRef.value(boxplot.median),
          strokeColor: boxplot.colors.boxStroke,
          strokeWidth: DefaultConfigs.BoxplotChart.boxStrokeWidth,
        },
        extreme: boxplot.extreme && {
          strokeColor: boxplot.colors.extremeStroke,
          strokeWidth: DefaultConfigs.BoxplotChart.extremeStrokeWidth,
          upper: boxplot.extreme.upper != null && {
            x1: xRef.value(boxplot.x) + halfXBandwidth - halfExtremeWidth,
            y1: yRef.value(boxplot.extreme.upper),
            x2: xRef.value(boxplot.x) + halfXBandwidth + halfExtremeWidth,
            y2: yRef.value(boxplot.extreme.upper),
          },
          lower: boxplot.extreme.lower != null && {
            x1: xRef.value(boxplot.x) + halfXBandwidth - halfExtremeWidth,
            y1: yRef.value(boxplot.extreme.lower),
            x2: xRef.value(boxplot.x) + halfXBandwidth + halfExtremeWidth,
            y2: yRef.value(boxplot.extreme.lower),
          },
          centerUpper: boxplot.extreme.upper != null && {
            x1: xRef.value(boxplot.x) + halfXBandwidth,
            y1: yRef.value(boxplot.extreme.upper),
            x2: xRef.value(boxplot.x) + halfXBandwidth,
            y2: yRef.value(boxplot.q3),
          },
          centerLower: boxplot.extreme.lower != null && {
            x1: xRef.value(boxplot.x) + halfXBandwidth,
            y1: yRef.value(boxplot.q1),
            x2: xRef.value(boxplot.x) + halfXBandwidth,
            y2: yRef.value(boxplot.extreme.lower),
          },
        },
        mean: boxplot.mean != null && {
          x: xRef.value(boxplot.x) + halfXBandwidth,
          y: yRef.value(boxplot.mean),
          strokeWidth: DefaultConfigs.BoxplotChart.meanStrokeWidth,
          strokeColor: boxplot.colors.meanStroke,
          radius: isIPadProRef?.value ? IPadProConfigs.BoxplotChart.meanRadius : DefaultConfigs.BoxplotChart.meanRadius,
        },
      });
    }

    boxplots.value = convertedData;
  };

  watch([dataRef, configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef], updateDataSet);

  onMounted(updateDataSet);

  return { boxplots };
}
